import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-flex notifications-wrap align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "icon-holder mr-3" }, null, -1)
const _hoisted_4 = { class: "add-notfication mr-3" }
const _hoisted_5 = { class: "d-flex notifications-wrap align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "icon-holder mr-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-bell" })
], -1)
const _hoisted_7 = { class: "dropdown mr-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Email", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "3" }, "SMS", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Notification", -1)
const _hoisted_11 = { class: "input-wrap mr-3" }
const _hoisted_12 = { class: "dropdown mr-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "1" }, "minutes", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: "2" }, "hours", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: "3" }, "days", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "4" }, "weeks", -1)
const _hoisted_17 = { class: "icon-holder" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-times" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("button", {
            class: "bg-light border rounded p-2",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNotification && _ctx.addNotification(...args)))
          }, " Add Notifications ")
        ])
      ])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.notificationList, (notification, notificationIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "form-group",
        key: notificationIndex
      }, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _withDirectives(_createVNode("select", {
              class: "form-control w-100",
              "onUpdate:modelValue": ($event: any) => (notification.notify_type = $event),
              onChange: ($event: any) => (
            _ctx.setNotificationBy(notification.notify_type, notificationIndex)
          )
            }, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10
            ], 40, ["onUpdate:modelValue", "onChange"]), [
              [_vModelSelect, notification.notify_type]
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _withDirectives(_createVNode("input", {
              type: "number",
              class: "bg-light border rounded p-2",
              "onUpdate:modelValue": ($event: any) => (notification.before = $event)
            }, null, 8, ["onUpdate:modelValue"]), [
              [_vModelText, notification.before]
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _withDirectives(_createVNode("select", {
              class: "form-control w-100",
              "onUpdate:modelValue": ($event: any) => (notification.before_type = $event),
              onChange: ($event: any) => (_ctx.setUnitBy(notification.before_type, notificationIndex))
            }, [
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16
            ], 40, ["onUpdate:modelValue", "onChange"]), [
              [_vModelSelect, notification.before_type]
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "text-danger",
              onClick: ($event: any) => (_ctx.removeSelected(notificationIndex))
            }, [
              _hoisted_18
            ], 8, ["onClick"])
          ])
        ])
      ]))
    }), 128))
  ], 64))
}